/**
 * Barra superior: logo da empresa (quando houver) + nome; FIUS como contexto de independência.
 */
import React from 'react';

export default function ComplaintPortalNavBar({ clientName, companyLogo, onDenunciar }) {
  const primary = clientName?.trim() || 'Canal de denúncias';

  return (
    <nav
      className="complaint-portal-nexus-nav fixed left-0 right-0 top-0 z-[100] flex min-h-[4.25rem] items-center justify-between gap-3 border-b border-black/[0.06] px-4 py-2 md:gap-4 md:px-10"
      style={{
        background: 'rgba(255,255,255,.92)',
        backdropFilter: 'blur(20px) saturate(180%)',
      }}
      aria-label="Navegação do canal"
    >
      <div className="flex min-w-0 flex-1 items-center gap-3 md:gap-4">
        {companyLogo ? (
          <img
            src={companyLogo}
            alt={`Logo ${primary}`}
            className="h-9 max-h-9 w-auto max-w-[min(42vw,168px)] shrink-0 object-contain object-left md:h-10 md:max-h-10 md:max-w-[200px]"
            loading="eager"
            decoding="async"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : null}
        <div className="min-w-0 flex-1">
          <p
            className="truncate font-semibold leading-tight text-[#111d30] md:text-[1.05rem]"
            style={{ fontFamily: "'Montserrat', system-ui, sans-serif" }}
            title={primary}
          >
            {primary}
          </p>
          <p
            className="mt-0.5 truncate text-[0.65rem] font-medium uppercase tracking-[0.14em] text-[rgba(17,29,48,0.48)]"
            style={{ fontFamily: "'Montserrat', system-ui, sans-serif" }}
          >
            Canal de denúncias · operação independente FIUS
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onDenunciar}
        className="flex-shrink-0 rounded-full px-4 py-2.5 text-[0.8rem] font-semibold text-white shadow-[0_10px_28px_rgba(0,158,219,.35)] transition-[opacity,transform] duration-200 sm:px-5"
        style={{
          fontFamily: "'Montserrat', system-ui, sans-serif",
          background: '#009edb',
          transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        Denunciar
      </button>
    </nav>
  );
}
